import { render, staticRenderFns } from "./select-industry.vue?vue&type=template&id=244668ac&scoped=true&"
import script from "./select-industry.vue?vue&type=script&lang=js&"
export * from "./select-industry.vue?vue&type=script&lang=js&"
import style0 from "./select-industry.vue?vue&type=style&index=0&id=244668ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244668ac",
  null
  
)

export default component.exports